import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "", inView = false }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      {...(inView
        ? { whileInView: { y: "0%" }, viewport: { once: true, margin: "-60px" } }
        : { animate: { y: "0%" } })}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Overline = ({ children, dark = false, className = "" }) => (
  <p
    className={`text-xs font-sans font-bold uppercase tracking-[0.28em] ${
      dark ? "text-clay" : "text-clay"
    } ${className}`}
  >
    {children}
  </p>
);
